import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "./vfs_fonts";
import moment from "moment";
import "moment/locale/th";
import { formatNumber } from "../../../utils/formatNumber";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew.ttf",
    italics: "THSarabunNew.ttf",
    bolditalics: "THSarabunNew.ttf",
  },
};

export function generateDeliveryNotePdfBlob(transaction) {
  const items = transaction.items || [];
  const totalWeight = items.reduce((s, i) => s + (i.weight || 0), 0);
  const totalDeduct = items.reduce((s, i) => s + (i.deductWeight || 0), 0);
  const totalNet = items.reduce((s, i) => s + (i.netWeight || 0), 0);

  const docDefinition = {
    content: [
      { text: "รายการขนส่งสินค้า", style: "header" },
      {
        text:
          `บริษัท มหานคร เมทอลสแคร็ป จำกัด\n92/78 หมู่ที่ 9 ถนนฉลองกรุง แขวงลำผักชี เขตหนองจอก กรุงเทพมหานคร 10530
โทร: 098-2657498 , 089-2029400\nเปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
        margin: [0, 10, 0, 10],
      },
      {
        columns: [
          [
            { text: `ชื่อรายการสินค้า: ${items[0]?.productName || "-"}` },
            { text: `เลขที่Batch: ${transaction.billNumber || "-"}` },
            { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
            {
              text:
                `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ${transaction.customerName || "-"}` +
                `\n${transaction.customer?.address || ""}`,
            },
            {
              text: transaction.customer?.phone
                ? `${transaction.customer.phone.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "",
            },
          ],
          [
            { text: `วันที่เปิดBatch ${moment(transaction.createdAt).add(543, "year").format("D/MM/YYYY HH:mm")}` },
            { text: `วันที่ขาย ${moment(transaction.shipping?.createdAt).add(543, "year").format("D/MM/YYYY HH:mm")}` },
            { text: `เลขตู้ขนส่ง: ${transaction.shipping?.transportBoxNumber || "-"}` },
            { text: `ชื่อคนขับ: ${transaction.shipping?.driverName || "-"}` },
            { text: `รถขนส่ง: ${transaction.car?.type || "-"} ${transaction.car?.license || "-"}` },
            {
              text: transaction.shipping?.phoneNumber
                ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "โทรศัพท์: -",
            },
          ],
        ],
        margin: [0, 10, 0, 10],
      },
      {
        table: {
          widths: ["*", "*", "*", "*", "*"],
          body: [
            [
              { text: "รายการ", bold: true },
              { text: "ประเภท", bold: true },
              { text: "รวม", bold: true, alignment: "right" },
              { text: "หัก", bold: true, alignment: "right" },
              { text: "สุทธิ", bold: true, alignment: "right" },
            ],
            ...items.map((it) => [
              it.productName || "-",
              it.unit || "กก.",
              { text: formatNumber(it.weight), alignment: "right" },
              { text: formatNumber(it.deductWeight), alignment: "right" },
              { text: formatNumber(it.netWeight), alignment: "right" },
            ]),
            [
              { text: `ทั้งหมด ${items.length} รายการ`, colSpan: 2 }, {},
              { text: formatNumber(totalWeight), alignment: "right" },
              { text: formatNumber(totalDeduct), alignment: "right" },
              { text: formatNumber(totalNet), alignment: "right" },
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },
      { text: `หมายเหตุ ${transaction.shipping?.note || "-"}`, margin: [0, 10, 0, 5] },
      { text: `เปิดBatchโดย ${transaction.shop?.name || "-"}`, margin: [0, 0, 0, 20] },
      { text: "ลงชื่อ: ____________________________ (ผู้เซ็นต์สินค้า)", margin: [0, 40, 0, 0] },
    ],
    styles: { header: { fontSize: 18, bold: true, alignment: "center", margin: [0,0,0,10] } },
    defaultStyle: { font: "THSarabunNew", fontSize: 16 },
  };

  return new Promise((resolve) => {
    pdfMake.createPdf(docDefinition).getBlob((blob) => resolve(blob));
  });
}

export function generateDeliveryNotePdf(transaction) {
  const items = transaction.items || [];
  const totalWeight = items.reduce((sum, item) => sum + (item.weight || 0), 0);
  const totalDeduct = items.reduce(
    (sum, item) => sum + (item.deductWeight || 0),
    0
  );
  const totalNet = items.reduce((sum, item) => sum + (item.netWeight || 0), 0);

  const docDefinition = {
    content: [
      { text: "รายการขนส่งสินค้า", style: "header" },

      {
        text: `บริษัท มหานคร เมทอลสแคร็ป จำกัด\n92/78 หมู่ที่ 9 ถนนฉลองกรุง แขวงลำผักชี เขตหนองจอก กรุงเทพมหานคร 10530
โทร: 098-2657498 , 089-2029400\nเปิด: จันทร์ - เสาร์ เวลา 8.00 - 16.00 น. (ปิดทุกวันอาทิตย์)`,
        margin: [0, 10, 0, 10],
      },

      {
        columns: [
          [
            { text: `ชื่อรายการสินค้า: ${items[0]?.productName || "-"}` },
            { text: `เลขที่Batch: ${transaction.billNumber || "-"}` },
            { text: `เลขที่ใบสั่งซื้อ: ${transaction.orderNumber || "-"}` },
            {
              text:
                `ส่งไปที่:\n[C${String(transaction.customerId || "-").padStart(3, "0")}] ` +
                `${transaction.customerName || "-"}` +
                `\n${transaction.customer?.address || ""}`,
            },
            {
              text: transaction.customer?.phone
                ? `${transaction.customer.phone.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "",
            },
          ],
          [
            {
              text: `วันที่เปิดBatch ${moment(transaction.createdAt)
                .add(543, "year")
                .format("D/MM/YYYY HH:mm")}`,
            },
            {
              text: `วันที่ขาย ${moment(transaction.shipping.createdAt)
                .add(543, "year")
                .format("D/MM/YYYY HH:mm")}`,
            },
            {
              text: `เลขตู้ขนส่ง: ${transaction.shipping.transportBoxNumber || "-"}`,
            },
            { text: `ชื่อคนขับ: ${transaction.shipping.driverName || "-"}` },
            {
              text: `รถขนส่ง: ${transaction?.car?.type || "-"} ${transaction?.car?.license || "-"}`,
            },
            {
              text: transaction.shipping?.phoneNumber
                ? `โทรศัพท์ ${transaction.shipping.phoneNumber.replace(/^(\d{3})(\d{7})$/, "$1-$2")}`
                : "โทรศัพท์: -",
            },
          ],
        ],
        margin: [0, 10, 0, 10],
      },

      {
        table: {
          widths: ["*", "*", "*", "*", "*"],
          body: [
            [
              { text: "รายการ", bold: true },
              { text: "ประเภท", bold: true },
              { text: "รวม", bold: true, alignment: "right" },
              { text: "หัก", bold: true, alignment: "right" },
              { text: "สุทธิ", bold: true, alignment: "right" },
            ],
            ...items.map((item) => [
              item.productName || "-",
              item.unit || "กก.",
              { text: formatNumber(item.weight), alignment: "right" },
              { text: formatNumber(item.deductWeight), alignment: "right" },
              { text: formatNumber(item.netWeight), alignment: "right" },
            ]),
            [
              { text: `ทั้งหมด ${items.length} รายการ`, colSpan: 2 },
              {},
              { text: formatNumber(totalWeight), alignment: "right" },
              { text: formatNumber(totalDeduct), alignment: "right" },
              { text: formatNumber(totalNet), alignment: "right" },
            ],
          ],
        },

        margin: [0, 10, 0, 10],
      },

      {
        text: `หมายเหตุ ${transaction.shipping.note || "-"}`,
        margin: [0, 10, 0, 5],
      },
      {
        text: `เปิดBatchโดย ${transaction.shop.name || "-"}`,
        margin: [0, 0, 0, 20],
      },

      {
        text: "ลงชื่อ: ____________________________ (ผู้เซ็นต์สินค้า)",
        margin: [0, 40, 0, 0],
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 10],
      },
    },
    defaultStyle: {
      font: "THSarabunNew",
      fontSize: 16,
    },
  };

  pdfMake.createPdf(docDefinition).open();
}
